import "./style.scss";

import { FC, HTMLAttributes } from "react";

import { HeadingItem } from "../HeadingItem/HeadingItem";

type Props = HTMLAttributes<HTMLUListElement>;

const Heading: FC<Props> = ({ ...props }) => {
  return (
    <ul {...props} className={"link-list-heading"}>
      <HeadingItem
        className="long-url-column"
        title="Long URL"
        property="url"
      />

      <HeadingItem className="owner-column" title="Owner" property="owner" />

      <HeadingItem
        className="date-added-column"
        title="Date Added"
        property="createdAt"
      />

      <HeadingItem className="views-column" title="Views" property="views" />

      <HeadingItem
        className="short-link-column"
        title="Short Link"
        property="shortUrl"
      />
    </ul>
  );
};

export default Heading;
